import { Button } from 'primereact/button'
import { alarmColors } from '../../types/alarm-consts'

interface ColorSelectorProps {
  label: string
  icon: string
  value: string
  onChange: (value: string, displayValue: string) => void
  onAdd: () => void
}

export const ColorSelector: React.FC<ColorSelectorProps> = ({
  label,
  icon,
  value,
  onChange,
  onAdd,
}) => {
  return (
    <div className='alarms-field'>
      <label className='alarms-label'>
        <i className={icon} />
        {label}
      </label>
      <div className='alarms-color-section'>
        <div className='alarms-color-grid'>
          {alarmColors.map((color) => (
            <div
              key={color.hex}
              className={`alarms-color-option ${value === color.value ? 'selected' : ''}`}
              onClick={() => onChange(color.value, color.name)}
            >
              <div
                className='alarms-color-circle'
                style={{
                  backgroundColor: color.hex,
                  border: color.hex === 'ffffff' ? '1px solid #dee2e6' : 'none',
                }}
              />
              <span className='alarms-color-label'>{color.name}</span>
              {value === color.name && (
                <i className='pi pi-check alarms-color-check' />
              )}
            </div>
          ))}
        </div>
        <Button
          icon='pi pi-plus'
          label='Adicionar Cor'
          onClick={onAdd}
          style={{ marginTop: '1rem', width: '100%' }}
          disabled={!value}
        />
      </div>
    </div>
  )
}
